import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">* * *</h4>

    <div class="poem">
      <p class="poem-block mb-3">
        En montaro alta, nekonata <br/>
        Misvojiĝis kavalir’ maljuna. <br/>
        Ŝvebis super li kondor’ malsata, <br/>
        Neĝ’ malvarmis sub la lumo luna.
      </p>

      <p class="poem-block mb-3">
        Pelis lin malsato en vagadon, <br/>
        Mortis la ĉeval’ en tago oka, <br/>
        Kaj por ne forlasi kamaradon, <br/>
        Restis li apude, sub la roko.
      </p>

      <p class="poem-block mb-3">
        Sidis li sub olda sikomoro, <br/>
        Rememoris sunon kaj Kastiljon, <br/>
        Sonĝis pri bataloj kaj amoro, <br/>
        Vidis jen fusilon, jem mantiljon.
      </p>

      <p class="poem-block mb-3">
        Estis li fiera kaj trankvila, <br/>
        Ne timigis lin venonta sorto. <br/>
        Venis mort’; kaj per la man’ facila <br/>
        Ludis li vetkubon kun la morto.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Rinocero</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Vidas vi, ke la simioj <br/>
        Sur lianoj, kun vekrioj <br/>
        Kiel longa kavalkado <br/>
        Kuras, kuras en horor’? <br/>
        Vi komprenu, ke sur pado <br/>
        Penetrante tra folioj <br/>
        Rinocer’ ĝin pelas for.
      </p>

      <p class="poem-block mb-3">
        En paniko eĉ bubalo <br/>
        Retiriĝas al ĝangalo, <br/>
        Piedfrapas la bestaro <br/>
        Sin savante de la mort’. <br/>
        Malamik’ de l’ ordinaro, <br/>
        Vin ne kaŝu vi en valo, <br/>
        Jen alvenis via sort’.
      </p>

      <p class="poem-block mb-3">
        Levu manojn al ĉielo, <br/>
        Kaj de tie, el la belo, <br/>
        Tra nebul’ de ĝoj’ kaj ploro <br/>
        Venos ŝipoj kun la kant’. <br/>
        Vi forgesos pri angoro <br/>
        Kaj sub rozkolora velo <br/>
        Flugos al beata land’.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">* * *</h4>
    

    <div class="poem">
      <p class="poem-block mb-3">
        Ĵuris li al la Madono, <br/>
        Ke fidele, kun atento <br/>
        Servos li al Damo bona, <br/>
        Necedema por la tento.
      </p>

      <p class="poem-block mb-3">
        Sed perdiĝis sankta ligo <br/>
        Dum diboĉoj en Parizo… <br/>
        Pereinte pro intrigo <br/>
        Venis li al Paradizo.
      </p>

      <p class="poem-block mb-3">
        Voĉ’ eksonis de l’ Madono: <br/>
        «Ĵuris vi, ke kun atento <br/>
        Servos vi al Damo bona, <br/>
        Necedema por la tento.
      </p>

      <p class="poem-block mb-3">
        Vi, ho ve, ne apartenas <br/>
        Al la puraj en animo. <br/>
        Kiu voton ne subtenas – <br/>
        - For de l’ Paradiza limo!»
      </p>

      <p class="poem-block mb-3">
        Sed petegis li Madonon, <br/>
        Konfesante kun lamento: <br/>
        «Mi nenie trovis bonan <br/>
        Damon, firman kontraŭ tento!»
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">La fondontoj…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Romul kaj Rem atingis supron <br/>
        De l’ muta monto, nuda, sen sem’. <br/>
        Romul diris: «Mi fondos urbon!» <br/>
        - «Urbon potencan!», - respondis Rem.
      </p>

      <p class="poem-block mb-3">
        Romul diris: «Laŭ vol’ de l’ dioj <br/>
        Ni reakiris brilon de glor’!» <br/>
        - «Ni forgesu pri ambicioj, - <br/>
        - Rem respondis. – Ek al labor’!»
      </p>

      <p class="poem-block mb-3">
        «Tie konstruos mi, - diris Romul, - <br/>
        Jen cirkon, domon laŭ mia skem’». <br/>
        - «Tamen, alproksimigu al domo <br/>
        - Kriptejojn kun tomboj» – respondis Rem.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">* * *</h4>

    

    <div class="poem">
      <p class="poem-block mb-3">
        La blankantaj arbotrunkoj en arbar’ <br/>
        Tre similis al la manoj de kadavr’, <br/>
        Kaj radikoj, aperantaj el la ter’, <br/>
        Montris vojon por iranta al infer’. <br/>
        Sub folioj ruĝe-flavaj de arbust’ <br/>
        Grandeguloj loĝis, nanoj kaj mangust’, <br/>
        Kaj en sablo oni vidis post la ŝtorm’ <br/>
        Spuron de pied’ sesfingra de la hom’. <br/>
        Sed neniam tie loĝis kavalir’, <br/>
        Nek rabisto, nek riĉulo el Kair’… <br/>
        Unufoje nur, vestita en brokat’, <br/>
        Venis ino kun la kapo de la kat’, <br/>
        Sed kronita per arĝenta diadem’… <br/>
        Ĝis mateno ŝi suferis kun la ĝem’ <br/>
        Kaj silente mortis antaŭ la aŭror’, <br/>
        Kiam benis paroĥanojn la pastor’. <br/>
        Tio estis, iam estis en pratemp’, <br/>
        Kiam regis sur la tero la printemp’, <br/>
        Tio estis, iam estis en la land’ – <br/>
        Nur en sonĝ’ al ni videblas ĝia rand’. <br/>
        Mi elpensis tion, rigardante vin, <br/>
        La okuloj ebriigas min sen vin’, <br/>
        La okuloj kun koloro de turkis’, <br/>
        Harplektaĵoj ruĝaj, buŝo por la kis’…
      </p>

      <p class="poem-block mb-3">
        Eble, ĉi-arbar’ – anim’ de vi, <br/>
        Eble, ĉi-arbar’ – la am’ de mi. <br/>
        Aŭ probable, kune post la mort’ <br/>
        Nin venigos tien nia sort’.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Leopardo</h4>

    <div class="poem">
      <p class="poem-block mb-3">
        Vekis min hodiaŭ sonĝ’ terura: <br/>
        Kvazaŭ mi brilegis en ĉielo, <br/>
        Sed la sort’, malica kaj tortura, <br/>
        Min forigis el la astra helo.
      </p>

      <p class="poem-block mb-3">
        Transformita tuj al leopardo <br/>
        Kaj freneza pro dezir’ akuta, <br/>
        Tremis mi de l’ flamiĝanta ardo, <br/>
        Strebis mi al sanga persekuto.
      </p>

      <p class="poem-block mb-3">
        Kaj al loko, kie loĝas Homo, <br/>
        Mi kaŝiris, dum mallum’ permesis, <br/>
        Por akiri en vilaĝa domo <br/>
        Manĝon, kiun Di al mi promesis.
      </p>

      <p class="poem-block mb-3">
        Sed sur voj’, pasante tra bosketo, <br/>
        Ekaperis hela junulino. <br/>
        Min impersis svelta silueto, <br/>
        Paŝ’ de  cerv’, rigardo de reĝino.
      </p>

      <p class="poem-block mb-3">
        Flustris mi: «Fantomo de la ĝojo, <br/>
        Dia fianĉin’, beleco sankta!» <br/>
        Kaj finiĝis tie mia vojo, <br/>
        Haltis min ŝi per rigard’ amanta.
      </p>

      <p class="poem-block mb-3">
        Mi silentis ĉe piedoj ŝiaj, <br/>
        Mi obeis al ordon’ senvorta, <br/>
        Kaj al mordoj de hundar’ rabia <br/>
        Lasis min, senpova kaj senvorta.
      </p>

      <p class="poem-block mb-3">
        Dume ŝi foriris el bosketo <br/>
        Per la paŝ’ tenera de vizio, <br/>
        Balanciĝis svelta silueto, <br/>
        Perloj brilis en la lunradio.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">* * *</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Dioj gloru vin, niaj konsuloj! <br/>
        Sendis vi al aren’ elefantojn, <br/>
        Ursojn, tigrojn per ardo flagrantajn <br/>
        Kun frenezaj pro sango okuloj.
      </p>

      <p class="poem-block mb-3">
        Ne ekvidus ni ja eĉ en Romo <br/>
        Tian lukton teruran kaj belan. <br/>
        Trian tagon ni spektas kruelan <br/>
        Ludon, best’ kontraŭ best’, sed sen homo.
      </p>

      <p class="poem-block mb-3">
        Kaj fin-fine al sanga areno <br/>
        Estis olda sorĉist’ elĵetita, <br/>
        Estro de alemanoj kaptita, <br/>
        La murdist’ kun rigard’ de hieno.
      </p>

      <p class="poem-block mb-3">
        Ho, ni tiel atendis la feston, <br/>
        Sciis ni, li fiera kaj brava! <br/>
        Mordu, bestoj! Nenio jam sava <br/>
        Por li restis. Disŝiru lin, bestoj!
      </p>

      <p class="poem-block mb-3">
        Sed subite, al ni sen atento, <br/>
        Li ekhurlis, kvieta kaj morna, <br/>
        Kaj forturnis sin bov’ akrokorna, <br/>
        Tigroj falis en tima silento.
      </p>

      <p class="poem-block mb-3">
        Kiom ni, ho konsuloj, ekmiris! <br/>
        Obeeme subigis la rostrojn <br/>
        Elefantoj, kaj lupoj la vostojn <br/>
        Pro la sango malsekajn, subtiris.
      </p>

      <p class="poem-block mb-3">
        Ho konsuloj kaj Dioj eternaj! <br/>
        Ĵuras ni, ke bestaro rabia <br/>
        Al sorĉisto silenta kaj pia <br/>
        Lekis krurojn kun ĝemoj konsternaj!
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">La ĝirafo</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Hodiaŭ mi vidas angoron en via rigard’, <br/>
        La brakoj subtilaj senmove min petas pri sav’… <br/>
        Aŭskultu, jen fore, ĉe bordo de Ĉad’ <br/>
        Vagadas gracia ĝiraf’.
      </p>

      <p class="poem-block mb-3">
        Langvoran gracilon kaj svelton li havas ĝis nun, <br/>
        Sur felo de li estas rava mirakl’-arabesk’, <br/>
        Simila al tiu, per kiu ornamas la lun’ <br/>
        Surfacon de lagoj, brilantaj pro la fosforesk’.
      </p>

      <p class="poem-block mb-3">
        Imitas li ŝipon kun veloj de bunta kolor’, <br/>
        Kaj lia kurado similas al flugo de bird’ <br/>
        Kantanta plenĝoje. Kaj kiam ekkuras li for, <br/>
        La sun’ estingiĝas, kliniĝas kaj velkas la mirt’.
      </p>

      <p class="poem-block mb-3">
        Mi scias la gajajn fabelojn de fora landar’ <br/>
        Pri nigra reĝino, pri amo de l’ arda junul’… <br/>
        Sed vi tro delonge suferis en morna malklar’, <br/>
        Ne volas vi kredi al io, krom pluv’ kaj nebul’.
      </p>

      <p class="poem-block mb-3">
        Nu kiel priskribu mi sudan ĝardenon sen pad’, <br/>
        Odoron de l’ herboj, la palmojn, belecon de pav’… <br/>
        Vi ploras… aŭskultu, jen fore, ĉe bordo de Ĉad’ <br/>
        Vagadas gracia ĝiraf’.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">La kruco</h4>

    <div class="poem">
      <p class="poem-block mb-3">
        Senĉese trompadis min kart’ post karto, <br/>
        Kaj vin’ jam ne savis de senesper’. <br/>
        La steloj malvarmaj, morozaj de marto <br/>
        Paliĝis en alt’ super nigra ter’.
      </p>

      <p class="poem-block mb-3">
        En morna frenezo, pasio ekscita, <br/>
        Jam profundiĝinta en luda hazard’, <br/>
        Mi ludis va-bankon – sed karto murdita. <br/>
        Jen kvazaŭ en sonĝo, kun svena rigard’
      </p>

      <p class="poem-block mb-3">
        El dom’ mi foriris. La helo aŭrora <br/>
        Tenere videblis en nokta angor’. <br/>
        Mi surgenuiĝis sur neĝ’ blukolora <br/>
        Premante al lipoj la krucon el or’.
      </p>

      <p class="poem-block mb-3">
        Mi estu libera, malriĉa kaj pia, <br/>
        Almozon mi petu je l’ nomo de Krist’, <br/>
        Vagante laŭ vojoj kun psalm’ eklezia <br/>
        Kaj kruc’, la simbol’ de l’ Ĉiela Ekzist…
      </p>

      <p class="poem-block mb-3">
        Moment’… En la halo gajplena kaj vanta <br/>
        Ekregis subite silent’ kaj horor’. <br/>
        Mi venis senbrida, pasia, tremanta <br/>
        Kaj metis sur karton la krucon el or’.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">La vorto</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Kiam al la mond’ ne sendis punon <br/>
        Di’ potenca, Mastr’ de nia sort’, <br/>
        Oni per la Vort’ haltigis sunon, <br/>
        Urbojn pereigis per la Vort’.
      </p>

      <p class="poem-block mb-3">
        Ne arogis suprenflugi aglo, <br/>
        Kaj timeme tremis la stelar’, <br/>
        Kiam Vort’, mistero kaj miraklo, <br/>
        Sur ĉielo brilis en malklar’.
      </p>

      <p class="poem-block mb-3">
        Kaj por viv’ kutima restis nombro, <br/>
        Obeema, kiel bona brut’, <br/>
        Tute klare ja, sen iu ombro <br/>
        Sencon montras ĝi en plena mut’.
      </p>

      <p class="poem-block mb-3">
        Jam scianta bonon kaj malbonon, <br/>
        Patriark’ meditis en silent’. <br/>
        Ne kuraĝis li alvoki sonon, <br/>
        Nombron li surstrekis kun prudent’.
      </p>

      <p class="poem-block mb-3">
        Sed forgesis ni, ke estas graca <br/>
        Nur la Vort’ en tera maltrankvil’; <br/>
        Apostolo Iohan’ sagaca <br/>
        Diris, ke la Vorto estas Di’.
      </p>

      <p class="poem-block mb-3">
        Tamen ni ĝin metas inter limoj <br/>
        De mizer’ natura kun obstin’, <br/>
        Kaj mortintaj vortoj, velkaj rimoj <br/>
        Putras solaj meze de ruin’.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">* * *</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Detruantan dispremos la plato <br/>
        El la dom’, detruata de li. <br/>
        Krios li en la mond’ senkompata, <br/>
        Sed por li restos surda la Di’.
      </p>

      <p class="poem-block mb-3">
        Konstruanta defalos de l’ muro, <br/>
        Estos longa sufera falad’. <br/>
        Li ne finos konstruon de l’ turo, <br/>
        Li malbenos la strebon al alt’.
      </p>

      <p class="poem-block mb-3">
        Forirantan al paca rivero <br/>
        Plu ne savos densega ĝangal’: <br/>
        Lin renkontos rabia pantero <br/>
        Kaj alkuros malica ŝakal’.
      </p>

      <p class="poem-block mb-3">
        Ne evitos vi sorton kruelan, <br/>
        Kiun planas por vi la destin’. <br/>
        Sed aprezu vi rajton plej belan: <br/>
        Mem elekti la morton por si!
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Soneto</h4>
    
    
    <div class="poem">
      <p class="poem-block mb-3">
        La kavaliro en kiraso fera, <br/>
        Mi gaje iras al lontana voj’. <br/>
        Jen mi ripozas en ĝarden’ kun ĝoj’, <br/>
        Jen proksimiĝas al abism’ mistera.
      </p>

      <p class="poem-block mb-3">
        En la ĉiel’, senstela kaj severa, <br/>
        Nebul’ aperas nigra foj-de-foj., <br/>
        Sed ridas mi, kaj kredas je la ĝoj’, <br/>
        Kaj l’ vojon sekvas kun arog’ fiera.
      </p>

      <p class="poem-block mb-3">
        Deziras mi ekregi vin, destin’! <br/>
        Kaj se aperos Morto en la fin’ – <br/>
        Alvenu ĝi. Mi pretas al batalo.
      </p>

      <p class="poem-block mb-3">
        Kun ĝi mi luktos ĝis la lasta spir’ <br/>
        Kaj prenos, en plenumo de l’ aspir’, <br/>
        Lilion bluan el la Morta Valo.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Don Ĵuan</h4>



    <div class="poem">
      <p class="poem-block mb-3">
        Mi revas kun arogo kaj fier’ <br/>
        Batali pro la frukt’ malpermesata, <br/>
        Hastante ĉiam kun pasi’ malsata <br/>
        Al nova amo, nova vivprosper’.
      </p>

      <p class="poem-block mb-3">
        Kaj en oldeco veni al la ver’ <br/>
        De l’ Kristanismo, pura kaj beata, <br/>
        Al monaĥej’ malriĉa, nekonata <br/>
        Foriri, kvazaŭ al la Sankta Ter’.
      </p>

      <p class="poem-block mb-3">
        Sed kiam mi, subite, inter kantoj <br/>
        Kaj krioj de diboĉoj triumfantaj <br/>
        Rekonsciiĝos, kvazaŭ somnambul’,
      </p>

      <p class="poem-block mb-3">
        Mi ekmemoros, ke en vivo vana <br/>
        Ne havis mi amikojn, sentaŭgul’, <br/>
        Kaj ne feliĉis pro ridet’ infana.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">La sesa sento</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        La vin’ benita feliĉigas nin, <br/>
        La pan’ fidela nutras ĉiiufoje, <br/>
        Kaj plej mirindas sur la ter’ virin’: <br/>
        Pro ŝi suferas ni, kaj poste ĝojas.
      </p>

      <p class="poem-block mb-3">
        Sed kiam sur malvarma firmament’ <br/>
        Aŭroro palas en kviet’ solena, <br/>
        En la anim’ vekiĝas kiu sent’? <br/>
        Por poezio kiu sens’ konvena?
      </p>

      <p class="poem-block mb-3">
        Ne taŭgas flar’, palpado kaj sapor’, <br/>
        Momento kuras preter ni senbride, <br/>
        Kaj ni etendas manojn kun angor’ <br/>
        Por vane peni kapti ĝin avide.
      </p>

      <p class="poem-block mb-3">
        Kiel la knabo juna kun ador’ <br/>
        Virinon nudan sekvas per rigardo, <br/>
        Malgraŭ ĉasteco sia kaj pudor’ <br/>
        Tremante pro nekomprenebla ardo,
      </p>

      <p class="poem-block mb-3">
        Kiel en pradensejo de lias’ <br/>
        Reptilo glita muĝis en sufero, <br/>
        Strebante al ĉiel’ per peza mas’, <br/>
        Sed sen flugil’ rampante sur la tero,
      </p>

      <p class="poem-block mb-3">
        Jen tiel, pro naturo kaj la art’, <br/>
        Post jaro jar’, jarcento post jarcento <br/>
        Kriegas la spirit’, suferas nia karn’ <br/>
        En nasko de organ’ por sesa sento.
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Nikolaj Gumilev'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;